/**
 * @fileoverview Social Post - JS for the social post page in the optimization flow
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.module('yext.storm.log.SocialPost');
goog.module.declareLegacyNamespace();

const PostBoxController = goog.require('yext.social.post.PostBoxController');

/** @constructor */
const SocialPost = function(options) {
  this.options = $.extend(true, {}, SocialPost.DEFAULT_OPTIONS, options);

  /** @type {PostBoxController} */
  this.postBox = new PostBoxController(this.options).init();

  this.init();
};

SocialPost.DEFAULT_OPTIONS = {
  alwaysOpened: true,
};

SocialPost.prototype.init = function() {
  this.bindCreatePost();
  this.bindDismiss();
};

SocialPost.prototype.bindCreatePost = function() {
  $(document).on('newPost.social', function() {
    $('.js-post-success').show();
    $('.js-next-button').removeClass('btn-disabled');
  });
};

SocialPost.prototype.bindDismiss = function() {
  $('.dismiss').on('click', function() {
    $(this).closest('.app-successbox').hide();
    return false;
  });
};

goog.exportSymbol('yext.storm.log.SocialPost', SocialPost);

exports = SocialPost;
